export const MAX_IMAGE_COUNT = 10;
export const MAX_VIDEO_COUNT = 10;
export const MAX_AUDIO_COUNT = 10;
export const MAX_DOCUMENT_COUNT = 10;
